import React, { useEffect, useState } from 'react';

import { InputGroup, TextField } from '../../../../../../Styles';

const ItemName = ({ label = 'Item Name', value = '', error = '', disabled = false, onChange = null, onError = null }) => {
	const [inputValue, setInputValue] = useState(value);

	const validate = () => {
		let error = null;

		if (!inputValue) {
			error = `${label} cannot be empty.`;
		} else if (inputValue?.length > 150) {
			error = `${label} is too long.`;
		}

		onError(error);
		return !error;
	};

	useEffect(() => {
		validate();
		onChange(inputValue);
	}, [inputValue]);

	useEffect(() => {
		setInputValue(value);
	}, [value]);

	return (
		<InputGroup
			label={label}
			markRequired={true}
			inputLength={(inputValue || '').length}
			maxLength={150}
			error={error}
		>
			<TextField
				name={'item_name'}
				placeholder='Enter value'
				value={inputValue}
				disabled={disabled}
				onChange={(e) => {
					setInputValue(e.target.value);
				}}
				error={error}
			/>
		</InputGroup>
	);
};

export default ItemName;
